/** What signing needs, stated once for the api's guards and the web's step list (screens §P6 Next step; content §2.7 THESIS_REQUIRED). */

/** The thesis line is required when no family changed, and a blank line (spaces only) is no line. */
export const thesisMissing = (thesis: { readonly required: boolean; readonly text: string | null }): boolean =>
  thesis.required && (thesis.text ?? "").trim() === "";
